export default __webpack_public_path__ + "static/media/Here_s My Chance.30d4885c.png";